import type { PropsWithChildren } from "react";

interface FileWrapperProps {
  className?: string;
  shouldShowDiv?: boolean;
  url?: string;
}

export const FileWrapper = ({
  children,
  className,
  shouldShowDiv,
  url,
}: PropsWithChildren<FileWrapperProps>) => {
  if (shouldShowDiv) {
    return <div className={className}>{children}</div>;
  }

  return (
    <a href={url} className={className} target="_blank" rel="noreferrer">
      {children}
    </a>
  );
};
